export default "__VITE_ASSET__Da07ALa2__"